import { parseISO } from 'date-fns';
import { Condition } from '@staffino/model';
import { ConditionEvaluatorContext } from '../condition-evaluator-context';

function convertToFormat(value: string | Date, _format: string) {
  if (_format === 'number') {
    return typeof value === 'string' ? Number.parseInt(value, 10) : value;
  }
  if (['date', 'time'].includes(_format)) {
    return typeof value === 'string' ? parseISO(value) : value;
  }
  return value;
}

// get seconds from midnight
function getSeconds(date: Date) {
  return date.getHours() * 3600 + date.getMinutes() * 60 + date.getSeconds();
}

export default async function input(
  condition: Condition,
  context: ConditionEvaluatorContext,
): Promise<boolean> {
  const { blockId, format, operator, value, length } = condition[1] ?? {};
  const formValue = context.stateManager.getState().formData[blockId];

  // check choices
  if (operator === 'empty') {
    return !formValue;
  }
  if (operator === '!empty') {
    return !!formValue;
  }
  if (operator === 'contains') {
    return formValue?.includes(value);
  }
  if (operator === '!contains') {
    return !formValue?.includes(value);
  }
  if (operator === '>' && format === 'time' && formValue) {
    const formDate: Date = convertToFormat(formValue, format) as Date;
    const conditionDate: Date = convertToFormat(value, format) as Date;
    return getSeconds(formDate) > getSeconds(conditionDate);
  }
  if (operator === '<' && format === 'time' && formValue) {
    const formDate: Date = convertToFormat(formValue, format) as Date;
    const conditionDate: Date = convertToFormat(value, format) as Date;
    return getSeconds(formDate) < getSeconds(conditionDate);
  }
  if (operator === '>' && length !== undefined && formValue) {
    return formValue?.length > length;
  }
  if (operator === '>' && format !== undefined && formValue) {
    return convertToFormat(formValue, format) > convertToFormat(value, format);
  }
  if (operator === '<' && length !== undefined && formValue) {
    return formValue?.length < length;
  }
  if (operator === '<' && format !== undefined && formValue) {
    return convertToFormat(formValue, format) < convertToFormat(value, format);
  }
  return false;
}
